import { render, staticRenderFns } from "./total-student-campus-and-pickup.vue?vue&type=template&id=350645c2&scoped=true&"
import script from "./total-student-campus-and-pickup.vue?vue&type=script&lang=js&"
export * from "./total-student-campus-and-pickup.vue?vue&type=script&lang=js&"
import style0 from "./total-student-campus-and-pickup.vue?vue&type=style&index=0&id=350645c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350645c2",
  null
  
)

export default component.exports